import { Ref } from '@vue/composition-api';
import { StringTranslator } from '@front-app/hooks/useTranslate';
import { UserSearchItem } from '@front-app/services/UserApi/UserModel';
import { Editor } from '@tiptap/core';

export const AT_MENTION_TAG = 'at-mention';

export interface AtMentionAttrs {
	id: string;
	label: string;
	userId: string;
}

export interface AtMentionConfig {
	mentionListRef: Ref<Vue | Element | null>;
	translationService: StringTranslator;
	mentionProvider: MentionProviderFunction;
}

export type MentionSelectFunction = (attrs: UserSearchItem) => void;
export interface MentionProviderArgs {
	query: string;
	editor: Editor;
}
export type MentionProviderFunction = (args: MentionProviderArgs) => Promise<UserSearchItem[]>;
